/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSidebarButtons_item = {|
  +isInProcurement?: ?boolean;
  +saveSearchData: ?{|
    +name: ?string;
    +page: ?string;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": "Boolean"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarButtons_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "SaveSearchDataType",
      "name": "saveSearchData",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "page",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestSourcingButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRequestPurchasingServiceButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedMakeOfferButton_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDeposit_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedAffirm_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchUser",
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "name": "isInProcurement",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item"
};

module.exports = fragment;
